module.exports = __webpack_public_path__ + "static/mo40-026f0b6197a6ae7ab65bae0f76f54285.png";